try {
  const availableSizeStrings = [
    "3xs",
    "2xs",
    "Xs",
    "X Small",
    "S",
    "Small",
    "M",
    "Medium",
    "L",
    "Large",
    "Xl",
    "X Large",
    "2xl",
    "3xl",
    "4xl",
    "1",
    "1.5",
    "2",
    "2.5",
    "3",
    "3.5",
    "4",
    "4.5",
    "5",
    "5.5",
    "6",
    "6.5",
    "7",
    "7.5",
    "8",
    "8.5",
    "9",
    "9.5",
    "10",
    "10.5",
    "11",
    "11.5",
    "12",
    "12.5",
    "13",
    "13.5",
    "14",
    "15",
    "2x Large",
    "3x Large",
    "4x Large",
    "2x Small",
    "3x Small",
    "45x34x15cm",
    "M1/W2.5",
    "M1.5/W3",
    "M2/W3.5",
    "M2.5/W4",
    "M3/W4.5",
    "M3.5/W5",
    "M4/W5.5",
    "M4.5/W6",
    "M5/W6.5",
    "M5.5/W7",
    "M6/W7.5",
    "M6.5/W8",
    "M7/W8.5",
    "M7.5/W9",
    "M8/W9.5",
    "M8.5/W10",
    "M9/W10.5",
    "M9.5/W11",
    "M10/W11.5",
    "M10.5/W12",
    "M11/W12.5",
    "M11.5/W13",
    "M12/W13.5",
    "M12.5/W14",
    "M13/W14.5",
    "M13.5/W15",
    "M14/W15.5",
    "M15/W16.5",
    "M16/W17.5",
    "M17/W18.5",
    "M18/W19.5",
    "Medium / Large",
    "One Size",
    "Small / Medium",
  ];

  const svgIcon = `
  <svg class="uae-dirham-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500" fill="currentColor" width="12" height="12" style="margin-right: 2px;">
    <path d="M474.94,1272.7H263.1a39.35,39.35,0,0,1-5-.1c-2.06-.28-3.18-1.34-1.43-3.29,30.93-34.3,40.49-76.77,46.14-120.72a396.09,396.09,0,0,0,2.84-49.77c.1-61.34,0-122.67.21-184,0-6.25-1.5-8.13-7.89-8-17.58.45-35.19.13-52.78.13-40.31,0-67-21-84.8-55.34-12-23.24-12-48.5-11.7-73.76,0-1.12-.22-2.59,1.23-3,1.65-.48,2.5,1,3.48,2,9,8.43,18.42,16.22,30.17,20.64a70.72,70.72,0,0,0,25,4.81c30,0,59.92-.12,89.87.13,5.54.05,7.4-1.3,7.34-7.13q-.42-44.92,0-89.86c.05-5.83-1.42-7.8-7.51-7.67-18.29.38-36.61.14-54.91.13-32.64,0-57-15.23-75-41.5-13.39-19.53-19.37-41.47-19.5-65.07,0-6.42-.17-12.84,0-19.25,0-2.16-1.54-5.44,1.28-6.25,2.06-.59,3.81,2.23,5.45,3.85,15.48,15.3,33.68,23.77,55.86,23.51,29.24-.34,58.49-.18,87.73,0,4.83,0,6.59-1.14,6.57-6.33-.31-65.37.28-130.75-.76-196.11-.71-44.65-8.34-88.23-28-129C271.89,251,265.14,241.34,257.92,232c-.82-1.07-2.76-1.71-2.19-3.26.71-1.91,2.76-1.4,4.39-1.4h8.56c127.91,0,255.82-.3,383.72.28,68.37.31,135.65,9.48,201.41,28.89,68,20.08,130,51.63,183.75,98.14,40.35,34.89,72.29,76.62,97,123.88a480.21,480.21,0,0,1,40.62,108.14c1.17,4.76,3.1,6.55,8.17,6.49,24-.24,48-.09,72,0,40.69.09,67.08,21.68,84.58,56.46,11.39,22.63,11.7,47.07,11.47,71.58,0,1.38.23,3.14-1.37,3.73-1.83.67-3-.82-4.16-2-8.21-8.33-17.39-15.22-28.3-19.73a67.66,67.66,0,0,0-25.65-5.26c-30.67-.12-61.34.08-92-.15-5.55,0-7.34,1.23-7,7.14a652.48,652.48,0,0,1,.07,89.75c-.48,6.85,1.8,7.87,7.79,7.75,17.11-.35,34.27.58,51.34-.24,46.19-2.24,80.8,30.71,93.43,70.73,6,19.15,5.81,38.77,5.64,58.45,0,1.13.51,2.59-1,3-1.92.54-3-1.18-4.15-2.25-8.74-8.43-18-16-29.58-20.36a66.74,66.74,0,0,0-23.55-4.75c-35.9-.07-71.8.06-107.7-.16-5.61,0-8,1.26-9.52,7.3-15.24,62.19-40.35,119.89-79.14,171.26s-87.42,91.1-144.44,120.61c-69.73,36.08-144.55,54.11-222.2,62.14-35,3.62-70.11,4.73-105.28,4.68q-74.9-.09-149.78,0ZM730.42,593.1V593q130.47,0,260.94.14c6.18,0,7.71-1.5,6.56-7.56-10.22-53.87-25.85-105.75-54.15-153.27-29.61-49.73-70.07-87.68-122-113.16C768.42,293,711.22,282.73,652.46,280.59c-60.56-2.22-121.18-.39-181.78-1-6.71-.07-8.21,1.89-8.19,8.33q.3,148.64,0,297.28c0,7,2.24,8.05,8.43,8Q600.66,592.95,730.42,593.1Zm.2,313.92V907q-130.15,0-260.3-.16c-6.38,0-7.83,1.7-7.82,7.93.21,95.32.12,190.63.22,286,0,6.31-2.84,14.49,1.35,18.46s12.26,1.26,18.6,1.17c60.34-.9,120.73,2.48,181-2.27,52-4.1,102.31-14.82,149.78-37,50.4-23.59,91.3-58.27,122.21-104.71,33-49.6,50.79-104.94,62.06-162.82,1.1-5.67-.69-6.6-6.1-6.59Q861.13,907.16,730.62,907Zm5.48-104.68v-.21c88.65,0,177.3-.09,265.95.19,6.38,0,8.23-1.78,8.36-7.71q1-44.91,0-89.8c-.13-5.47-1.76-7.17-7.47-7.16q-265.95.27-531.9,0c-7.12,0-8.6,2.25-8.52,8.88.34,28.75.17,57.51.16,86.26,0,9.54-.05,9.53,9.66,9.53Z" style="fill:currentColor"/>
  </svg>
`;

  function modifyPriceStructure(tooltip) {
    return tooltip.innerHTML.replace(/^Dhs\.\s*/, svgIcon);
  }

  function showCloseBtnInMobileInInput() {
    if(window.innerWidth < 768) {
      const searchInput = document.querySelector(".header__search-block-Mob #Search-In-Modal");
      const closeBtn = document.querySelector(".header__search-block-Mob .reset__button");
      if(searchInput) {
        searchInput.addEventListener('click', () => {
          if(closeBtn && closeBtn.classList.contains('hidden')) {
            closeBtn.classList.remove('hidden');
          }
        })
      }
    }
  }
  showCloseBtnInMobileInInput();
  
  function createViewMoreBtn(itemsToShowCount, element, facetItems, viewMoreBtn) {
    const initialItemsToShow = itemsToShowCount;
    let itemsToShow = initialItemsToShow;
    let isExpanded = false;
    
    viewMoreBtn.style.display = "flex";
    viewMoreBtn.textContent = "View More";

    const updateVisibility = () => {
      facetItems.forEach((item, index) => {
        if (index < itemsToShow) {
          item.classList.remove("visible");
        } else {
          item.classList.add("visible");
        }
      });
    };
    // Initial state
    updateVisibility();
    
    viewMoreBtn.addEventListener("click", () => {
      if (!isExpanded) {
        // VIEW MORE
        itemsToShow = facetItems.length;
        viewMoreBtn.textContent = "View Less";
        isExpanded = true;
      } else {
        // VIEW LESS
        itemsToShow = initialItemsToShow;
        viewMoreBtn.textContent = "View More";
        isExpanded = false;
      }
      updateVisibility();
    });
  }

  function OpenFilters() {
    let searchWrapper = document.querySelector(
      ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results "
    );
    let filterWrapper = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
    );
    let wizzySearchFiltersLeft = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-results-wrapper .wizzy-search-filters-left"
    );
    let navBar = document.querySelector(".wizzy-search-results");
    if (searchWrapper) searchWrapper.classList.add("filter-opened");
    if (filterWrapper) filterWrapper.classList.add("opened");
    if (wizzySearchFiltersLeft) wizzySearchFiltersLeft.classList.add("opened");
    let textFilter = document.querySelector(".wizzy-filters-button-text");
    if (textFilter) textFilter.innerText = "Hide Filter";
  }

  function CloseFilters() {
    let filterWrapper = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
    );
    let searchWrapper = document.querySelector(
      ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results "
    );
    let wizzySearchFiltersLeft = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-results-wrapper .wizzy-search-filters-left"
    );
    if (searchWrapper) searchWrapper.classList.remove("filter-opened");
    if (filterWrapper) filterWrapper.classList.remove("opened");
    if (wizzySearchFiltersLeft)
      wizzySearchFiltersLeft.classList.remove("opened");

    let textFilter = document.querySelector(".wizzy-filters-button-text");
    if (textFilter) textFilter.innerText = "Show Filter";
  }

  function handleFilterClick(e) {
    e.preventDefault();
    let filter_open = localStorage.getItem("filter_opened") || 1;

    if (filter_open == 0) {
      OpenFilters();
      localStorage.setItem("filter_opened", 1);
    } else {
      CloseFilters();
      localStorage.setItem("filter_opened", 0);
    }
  }

  // Boosting Collection Pages Sort Order Code Starts
  var realPage = 1;
  var lastProductId = null;
  var boostingDone = false;
  var wizzyCollectionProductIds2 = [];
  // Boosting Collection Pages Sort Order Code Ends

  window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (payload) {
        window.wizzyConfig.search.configs.general.minQueryLength = 1;
        if (window.innerWidth < 768) {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: ".header__search-block-Mob #Search-In-Modal",
            type: "search",
          };
        } else {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: ".header__search-block #Search-In-Modal",
            type: "search",
          };
        }

        payload.search.configs.pagination.appendInExistingList = "true";
        payload.filters.configs.layout = "v1";
        window.wizzyConfig.common.isOnCategoryPage == true ? 
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"] : 
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply =
          "true";
        window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
          "true";

        window.wizzyConfig.store.currency.symbol = "Dhs.";

        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (payload) {
        window.wizzyConfig.search.configs.general.minQueryLength = 1;
        
        if (window.innerWidth < 768) {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: ".header__search-block-Mob #Search-In-Modal",
            type: "search",
          };
        } else {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: ".header__search-block  #Search-In-Modal",
            type: "search",
          };
        }

        payload.search.configs.pagination.appendInExistingList = "true";
        payload.filters.configs.layout = "v1";
        window.wizzyConfig.common.isOnCategoryPage == true ? 
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"] : 
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];

        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply =
          "true";
        window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
          "true";
        window.wizzyConfig.store.currency.symbol = "Dhs.";

        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // payload.ignoreRelaxed= "true";
        payload.minQueryLength = 1;
        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (payload) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] = "body main";
        payload.attributeFacetValuesLimit = 100;
        payload.minQueryLength = 1;
        
        const collectionPageBannerEle = document.querySelector(
        ".shopify-section.section-collection-banner"
        );
        if (collectionPageBannerEle) {
          collectionPageBannerEle.style.display = "none";
        }
        
        /**
         * code for bread crumbs on search page - starts here
         */
        /*
        const searchPageBreadcrumbEle = document.querySelector(".container");
        if (searchPageBreadcrumbEle) {
          searchPageBreadcrumbEle.style.setProperty("display","block","important");
        }

        const breadCrumbList = document.querySelector(".container .breadcrumbs .breadcrumbs__list");
        const breadCrumbSearchQuery = document.querySelector(".container .breadcrumbs .breadcrumbs__list .search-item .search-query");
        if (breadCrumbList && payload.q) {
          let existingItem = breadCrumbList.querySelector(".breadcrumbs__item.search-item");
          
          if (!existingItem) {
            const li = document.createElement("li");
            li.className = "breadcrumbs__item search-item";
            li.innerHTML = `/ <a class="breadcrumbs__link" href="${window.location.href}" aria-current="page">
                Search results for: <span class="search-query">${payload.q}</span>
              </a>`;
              breadCrumbList.appendChild(li);
          } else {
              const queryEl = existingItem.querySelector(".search-query");
              if (queryEl && queryEl.textContent !== payload.q) {
                queryEl.textContent = payload.q;
              }
          }
        }*/
        /**
         * code for bread crumbs on search page - ends here
        */
      
      
        const main = document.querySelector("#MainContent");
        const classToRemoveFromMain = ['template-cart','is-empty','template-account','template-account_return'];
        if (main) {
          classToRemoveFromMain.forEach(cls => {
            if (main.classList.contains(cls)) {
              main.classList.remove(cls);
            }
          });
        }

        const productModal = document.querySelector(
          ".product-media-modal.media-modal"
        );
        if (productModal) {
          productModal.style.display = "none";
        }

        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (payload) {
        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        if (products) {
          products.forEach((product) => {
            if (product.attributes) {
              product.attributes.forEach((attr) => {
                if (attr.id === "product_handle") {
                  product.handle = attr.values[0].value[0];
                }
                if (attr.id === "product_model_number_custom") {
                  product.modelNumber = attr.values[0].value[0];
                }
              });
            }

            if (product.mainImage == "https://via.placeholder.com/360x360") {
              product.mainImage =
                "https://cdn.shopify.com/s/files/1/0933/9073/3586/files/default-1080x1000.png?v=1747392975";
            }
          });
        }
        return products;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (payload) {
        
        try {
          
          window.collectionSwatches = new CollectionProductSwatches();
          
  
          // Clean up observer when page unloads
          // window.addEventListener('beforeunload', () => {
          //   if (window.collectionSwatches && window.collectionSwatches.observer) {
          //     window.collectionSwatches.observer.disconnect();
          //   }
          // });
          
          if (
            (payload.data.api === "search" || payload.data.api === "filter") &&
            payload.data.response.payload.total !== 0
          ) {
            
            if (window.innerWidth < 768) {
              //
              var filterCloseBtnMobile = document.querySelector(
                ".wizzy-filters-close-btn"
              );
              var applyFilterBtnMobile = document.querySelector(
                ".wizzy-search-filters-left #MobileApplyFiltersButton"
              );
              var filterOverlay = document.querySelector(".wizzy-filters-bg");

              if (filterCloseBtnMobile && applyFilterBtnMobile) {
                filterCloseBtnMobile.addEventListener("click", function () {
                  if (filterOverlay) {
                    filterOverlay.click();
                  }
                });

                applyFilterBtnMobile.addEventListener("click", function () {
                  if (filterOverlay) {
                    filterOverlay.click();
                  }
                });
              }

              //
              var sourceElement = document.querySelector(
                ".wizzy-search-sort-wrapper"
              );
              if (sourceElement) {
                var clonedContent = sourceElement.cloneNode(true);
                var targetDiv = document.querySelector(
                  ".wizzy-sort-wrapper-in-filter"
                );
                if (
                  targetDiv &&
                  !targetDiv.querySelector(".wizzy-search-sort-wrapper")
                ) {
                  targetDiv.appendChild(clonedContent);
                }
              }

              var sortInFilter = document.querySelector(
                ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
              );
              if (
                sortInFilter &&
                !sortInFilter.classList.contains("click-listener-attached")
              ) {
                sortInFilter.addEventListener("click", function (event) {
                  event.preventDefault();
                  event.stopPropagation();
                  var sortOptions = document.querySelector(
                    ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
                  );
                  if (sortOptions) {
                    if (
                      sortOptions.style.display === "none" ||
                      sortOptions.style.display === ""
                    ) {
                      sortOptions.style.display = "grid";
                    } else {
                      sortOptions.style.display = "none";
                    }
                  }
                  sortInFilter.classList.add("click-listener-attached");
                });
              }
            }

            let filterButton = document.querySelector(
              ".wizzy-search-filters-drawer-button"
            );
            if (window.innerWidth > 768) {
              let filter_open = localStorage.getItem("filter_opened") || 1;
              if (filter_open == 1) {
                OpenFilters();
              } else {
                CloseFilters();
              }
              if (filterButton) {
                filterButton.removeEventListener("click", handleFilterClick);
                filterButton.addEventListener("click", handleFilterClick);
              }
            }

            // code to show total number of products shown in total
            const productCountMessage = document.querySelector(
              ".wizzy-search-pagination .product-progress-container #product-count-message"
            );
            const progressBar = document.querySelector(".wizzy-search-pagination .product-progress-track #product-progress-bar");
            if (
              productCountMessage &&
              payload.data &&
              payload.data.response &&
              payload.data.response.payload
            ) {
              var viewedProducts = 0;
              if (
                payload.data.response.payload.pages ==
                payload.data.response.payload.filters.page
              ) {
                viewedProducts =
                  (payload.data.response.payload.filters.page - 1) *
                    payload.data.response.payload.filters.productsCount +
                  payload.data.response.payload.result.length;
              } else {
                viewedProducts =
                  payload.data.response.payload.filters.page *
                  payload.data.response.payload.result.length;
              }
              const totalProucts = payload.data.response.payload.total;
              const percentageOfProductsViewed = (viewedProducts/totalProucts) * 100;
              countMessage = `You've viewed ${viewedProducts} of ${totalProucts} products`;

              productCountMessage.innerHTML = countMessage;
              progressBar.style.width = percentageOfProductsViewed + '%';
            }

            //change Dhs. with svg inside price filter
            const labels = document.querySelectorAll(
                '[data-facetkey="sellingPrice"] .facet-item-label-value'
              ),
              minToolTip = document.querySelector(
                ".noUi-handle-lower .noUi-tooltip"
              ),
              maxToolTip = document.querySelector(
                ".noUi-handle-upper .noUi-tooltip"
              );
            // minToolTip.innerHTML = modifyPriceStructure(minToolTip);
            // maxToolTip.innerHTML = modifyPriceStructure(maxToolTip);

            //change symbol in selected filter
            const selectedPriceFilters = document.querySelectorAll(
              ".wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-key='_sellingPrice'] .facet-item-label-value"
            );

            if (selectedPriceFilters) {
              selectedPriceFilters.forEach((selectedPriceFilter) => {
                selectedPriceFilter.innerHTML = `${minToolTip.innerHTML} - ${maxToolTip.innerHTML}`;
              });
            }

            const handleElement = document.querySelector(".noUi-handle");
            const observer2 = new MutationObserver(function (
              mutationsList,
              observer3
            ) {
              for (let mutation of mutationsList) {
                if (
                  mutation.attributeName === "aria-valuemax" ||
                  mutation.attributeName === "aria-valuemin"
                ) {
                  const minToolTip2 = document.querySelector(
                    ".noUi-handle-lower .noUi-tooltip"
                  );
                  const maxToolTip2 = document.querySelector(
                    ".noUi-handle-upper .noUi-tooltip"
                  );

                  minToolTip2.innerHTML = modifyPriceStructure(minToolTip2);
                  maxToolTip2.innerHTML = modifyPriceStructure(maxToolTip2);
                }
              }
            });
            const observerConfig = {
              attributes: true,
            };
            observer2.observe(handleElement, observerConfig);


            /*view more button - starts here*/
            payload.data.response.payload.facets.forEach((facet) => {
              if (facet.data.length > 10) {
                const element = document.querySelector('[data-key="' + facet.key + '"]');
                const facetItems = element.querySelectorAll(".wizzy-facet-body .wizzy-facet-list li");
                const viewMoreBtn = element.querySelector(".wizzy-view-more-btn");
                createViewMoreBtn(10, element, facetItems, viewMoreBtn);          
              }
            });
            /*view more button - ends here*/
          }
          
          if (window._swat) {
            window._swat.initializeActionButtons(".wizzy-search-results");
          }

          if (payload.data.api === "autocomplete" || payload.data.api === "filter" && payload.data.response.payload.filters.type === "AUTOCOMPLETE_DEFAULT") {
            if (window.innerWidth > 768) {
              const searchInput2 = document.querySelector(".header__search-block  #Search-In-Modal");
              const wizzyAutocompleteWrapper2 = document.querySelector(".wizzy-autocomplete-wrapper.withoutSuggestions");
              if (wizzyAutocompleteWrapper2) {
                const rect = searchInput2.getBoundingClientRect();
                wizzyAutocompleteWrapper2.style.setProperty("left", `${rect.left + rect.width / 2}px`, "important");
                wizzyAutocompleteWrapper2.style.transform = "translateX(-50%)";
              }
            }
            _swat.initializeActionButtons(".autocomplete-top-products")
          }
        } catch (error) {
          console.log(error);
        }


        if (window.wizzyConfig.common.isOnCategoryPage) {
          const collectionSummaryEle = document.querySelector(".wizzy-search-filters-top.visible-desktop.hide-mobile .wizzy-search-summary-container");
          if (!collectionSummaryEle.querySelector(".wizzy-summary-head")) {
            const collectionHeadEle = document.createElement('p');
            collectionHeadEle.className = "wizzy-summary-head";

            const collectionProductCountEle = document.createElement('span');
            collectionProductCountEle.className = "wizzy-summary-count";
            collectionProductCountEle.innerHTML = "[" + payload?.data?.response?.payload?.total + "]";


            const collectionNameEle = document.createElement("span");
            collectionNameEle.className = "wizzy-summary-query";
            collectionNameEle.innerHTML = window.wizzyConfig.common.categoryName;
            
            if (collectionSummaryEle) {
              collectionHeadEle.appendChild(collectionNameEle);
              collectionHeadEle.appendChild(collectionProductCountEle);
              collectionSummaryEle.appendChild(collectionHeadEle);
            } 
          }
        } 

        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (payload) {
        try {
          if (payload.api === "search" || payload.api === "filter") {
            var facets = payload.response.payload.facets;
            facets.forEach((facet) => {
              if (facet.key === "product_Size") {
                let m = facet.data.length,
                  newArray = [];
                for (let ii = 0; ii < availableSizeStrings.length; ii++) {
                  for (let jj = 0; jj < m; jj++) {
                    if (facet.data[jj].key === availableSizeStrings[ii]) {
                      newArray.push(facet.data[jj]);
                    }
                  }
                }
                facet.data = newArray;
              }

              if (facet.key === "product_reebok_sports_custom") {
                facet.data = facet.data.map(item => ({
                  ...item,
                  label: item.label.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
                }));
              }


            });
          }
        } catch (error) {
          console.log(error);
        }
        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (payload) {
        
        if (window.innerWidth < 768) {
          var filterCloseBtnMobile = document.querySelector(
            ".wizzy-filters-close-btn"
          );
          var applyFilterBtnMobile = document.querySelector(
            ".wizzy-search-filters-left .wizzy-search-filters-left-wrapper #MobileApplyFiltersButton"
          );
          var filterOverlay = document.querySelector(".wizzy-filters-bg");

          if (filterCloseBtnMobile && applyFilterBtnMobile) {
            filterCloseBtnMobile.addEventListener("click", function () {
              if (filterOverlay) {
                filterOverlay.click();
              }
            });

            applyFilterBtnMobile.addEventListener("click", function () {
              if (filterOverlay) {
                filterOverlay.click();
              }
            });
          }

          //
          var sourceElement = document.querySelector(
            ".wizzy-search-sort-wrapper"
          );
          if (sourceElement) {
            var clonedContent = sourceElement.cloneNode(true);
            var targetDiv = document.querySelector(
              ".wizzy-sort-wrapper-in-filter"
            );
            if (
              targetDiv &&
              !targetDiv.querySelector(".wizzy-search-sort-wrapper")
            ) {
              targetDiv.appendChild(clonedContent);
            }
          }

          var sortInFilter = document.querySelector(
            ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
          );
          if (
            sortInFilter &&
            !sortInFilter.classList.contains("click-listener-attached")
          ) {
            sortInFilter.addEventListener("click", function (event) {
              event.preventDefault();
              event.stopPropagation();
              var sortOptions = document.querySelector(
                ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
              );
              if (sortOptions) {
                if (
                  sortOptions.style.display === "none" ||
                  sortOptions.style.display === ""
                ) {
                  sortOptions.style.display = "grid";
                } else {
                  sortOptions.style.display = "none";
                }
              }
              sortInFilter.classList.add("click-listener-attached");
            });
          }
        }

        let filterButton = document.querySelector(
          ".wizzy-search-filters-drawer-button"
        );
        if (window.innerWidth > 768) {
          let filter_open = localStorage.getItem("filter_opened") || 1;
          if (filter_open == 1) {
            OpenFilters();
          } else {
            CloseFilters();
          }
          if (filterButton) {
            filterButton.removeEventListener("click", handleFilterClick);
            filterButton.addEventListener("click", handleFilterClick);
          }
        }

        //change Dhs. with svg inside price filter
        const labels = document.querySelectorAll(
            '[data-facetkey="sellingPrice"] .facet-item-label-value'
          ),
          minToolTip = document.querySelector(
            ".noUi-handle-lower .noUi-tooltip"
          ),
          maxToolTip = document.querySelector(
            ".noUi-handle-upper .noUi-tooltip"
          );
        minToolTip.innerHTML = modifyPriceStructure(minToolTip);
        maxToolTip.innerHTML = modifyPriceStructure(maxToolTip);

        //change symbol in selected filter
        const selectedPriceFilters = document.querySelectorAll(
          ".wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-key='_sellingPrice'] .facet-item-label-value"
        );

        if (selectedPriceFilters) {
          selectedPriceFilters.forEach((selectedPriceFilter) => {
            selectedPriceFilter.innerHTML = `${minToolTip.innerHTML} - ${maxToolTip.innerHTML}`;
          });
        }

        const handleElement = document.querySelector(".noUi-handle");
        const observer2 = new MutationObserver(function (
          mutationsList,
          observer3
        ) {
          for (let mutation of mutationsList) {
            if (
              mutation.attributeName === "aria-valuemax" ||
              mutation.attributeName === "aria-valuemin"
            ) {
              const minToolTip2 = document.querySelector(
                ".noUi-handle-lower .noUi-tooltip"
              );
              const maxToolTip2 = document.querySelector(
                ".noUi-handle-upper .noUi-tooltip"
              );

              minToolTip2.innerHTML = modifyPriceStructure(minToolTip2);
              maxToolTip2.innerHTML = modifyPriceStructure(maxToolTip2);
            }
          }
        });
        const observerConfig = {
          attributes: true,
        };
        observer2.observe(handleElement, observerConfig);
        
        return payload;
      }
    );

    /* boostgroup ID code - starts here*/
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (window.wizzyConfig.common.isOnCategoryPage) {
        data.filters.attributeFacetValuesLimit = 100;
        var hasQueryParams = window.location.search && window.location.search.length > 1;
        var hasFilterApplied = hasAppliedFilters(data);
        data.filters.productsCount = window.wizzyConfig.search.configs.general.noOfProducts;
        var productsCount = data.filters?.productsCount ?? 50;
        var currentPage = realPage ?? 1;
        var totalPages = window.wizzyConfig?.pageStore?.searchedResponse?.pages;
        if (currentPage === 42) {
          data.filters.page = currentPage;
        }
        if(hasFilterApplied) {
          if(data.filters.boostGroupIds && data.filters.boostGroupIds.length > 0) {
            delete data.filters.boostGroupIds;
          }
          lastProductId = null;
          boostingDone = false;
        }
        console.log("WIZZY boosting OLD", hasQueryParams, productsCount, currentPage, totalPages);
        if (typeof window.inStockProducts != "undefined" && window.inStockProducts && !hasFilterApplied && realPage < 43 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
          if (data.filters && data.filters.sort && data.filters.sort.length > 0 && data.filters.sort[0].field === "relevance" && window.inStockProducts && window.inStockProducts.length > 0) {
            // wizzyCollectionProductIds = wizzyCollectionProductIds.slice(0, productsCount);
            if (realPage === totalPages + 1) {
              data.filters.page = totalPages + 1;
            }
            // var wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIds1.slice(0, Math.floor(1000 / productsCount) * productsCount);
            // var start = (currentPage - 1) * productsCount;
            // var end = currentPage * productsCount;
            // var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
            // NEW LOGIC STARTS
            // NEW LOGIC STARTS - 17 OCT
            var adjustedLength = Math.floor(window.inStockProducts.length / productsCount) * productsCount;
            wizzyCollectionProductIds2 = window.inStockProducts.slice(0, adjustedLength);
            // NEW LOGIC ENDS - 17 OCT
            var start = 0;
            if (typeof lastProductId !== "undefined" && lastProductId) {
              var lastIndex = wizzyCollectionProductIds2.indexOf(lastProductId);
              // NEW LOGIC STARTS - 17 OCT
              if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                boostingDone = true;
              }
              // NEW LOGIC ENDS - 17 OCT

              if (lastIndex !== -1) {
                start = lastIndex + 1; // start after the last used product
              }
            } else {
              // fallback to old pagination if no lastProductId available
              start = (currentPage - 1) * productsCount;
            }
            var end = (currentPage * productsCount) + productsCount;
            var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
            if (wizzyCollectionBoostedProductIds.length > 50) {
              wizzyCollectionBoostedProductIds = wizzyCollectionBoostedProductIds.slice(0, 50);
            }
            // NEW LOGIC STARTS - 17 OCT
            if (wizzyCollectionBoostedProductIds.length === 0) {
              boostingDone = true;
            }
            // NEW LOGIC ENDS - 17 OCT
            // NEW LOGIC ENDS
            console.log("WIZZY boosting", wizzyCollectionProductIds2, start, end, wizzyCollectionBoostedProductIds);
            if (wizzyCollectionBoostedProductIds.length > 0) {
              realPage++;
            // console.log("WIZZY boosting 1", realPage);
              data.filters.boostGroupIds = wizzyCollectionBoostedProductIds;
              if (totalPages) {
                if (realPage !== totalPages + 2) {
                  data.filters.page = 1;
                }
              }
              if (wizzyCollectionBoostedProductIds.length < productsCount) {
                data.filters.productsCount = wizzyCollectionBoostedProductIds.length;
              }
            }
          } else {
            realPage++;
          }
        } else {

            if(realPage === 1 && !hasFilterApplied && typeof window.inStockProducts != "undefined" && window.inStockProducts) {
              var wizzyCollectionProductIdsNew = window.inStockProducts.slice(0, 48);
              data.filters.boostGroupIds = wizzyCollectionProductIdsNew;
            }
            data.filters.page = realPage;
          realPage++;
          // NEW LOGIC ENDS - 17 OCT
        }
      }
      
      return data;
    }, 3
  );
  /* boostgroup ID code - ends here*/

  /* boostgroup ID code - starts here*/
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      var filterItems = document.querySelectorAll('.wizzy-facet-list-item');

      if (filterItems.length > 0) {
        filterItems.forEach((filterItem) => {
          filterItem.addEventListener('click', function(){
            realPage = 1;
          });
        })
      }

      var sortItems = document.querySelectorAll('.wizzy-common-select-option');

      if (sortItems.length > 0) {
        sortItems.forEach((soertItem) => {
          soertItem.addEventListener('click', function(){
            realPage = 1;
          });
        })
      }
      return payload;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      if(window.wizzyConfig.common.isOnCategoryPage) {
        var tempPage = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.page;
  
        if (tempPage && realPage > 1) {
          var tempRealPage = realPage - 1;
          data.response.payload.filters.page = tempRealPage;
        }
      }

      var results = data.response?.payload?.result;

      if (results && results.length > 0) {
        var lastProduct = results.at(-1);
        var lastId = lastProduct?.groupId || lastProduct?.id || null;
        if (lastId) lastProductId = parseInt(lastId);
        try {
          var hasFilterApplied = hasAppliedFilters(data.response.payload);
        } catch (error) {
          console.log("Errr : ",error);
        }
        if(hasFilterApplied) {
          console.log("WIZZY boosting last null");
          lastProductId = null;
          boostingDone = false;
        }
        if (lastProductId && wizzyCollectionProductIds2.length > 0) {
          if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
            boostingDone = true;
          }
        }
      }

      return data;
    });

  /* boostgroup ID code - ends here*/


  };
} catch (error) {
  console.log(error);
}


/* boostgroup ID code - starts here*/

$("body").on("click", ".wizzy-selected-facet-list-item,.wizzy-facet-list-item", function(event) {
  // console.log("Wiz FACET clicked", realPage);
  if (realPage !== 1) {
    realPage = 1;
  }

});

$("body").on("click", ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all", function(event) {
  // console.log("Wiz reset clicked", realPage);
  if (realPage !== 1) {
    realPage = 1;
  }

});

function hasAppliedFilters(data) {
  if (!data || !data.filters) return false;

  let filters = data.filters;

  // If filters is string → parse it
  if (typeof filters === "string") {
    try {
      filters = JSON.parse(filters);
    } catch (e) {
      return false;
    }
  }

  // 1. Check attributes
  if (filters.attributes && typeof filters.attributes === "object") {
    for (const key in filters.attributes) {
      const value = filters.attributes[key];
      if (Array.isArray(value) && value.length > 0) {
        return true;
      }
    }
  }

  // 2. Check other filter keys
  const filterKeysToCheck = [
    "brands",
    "colors",
    "sizes",
    "genders",
    "sellingPrice",
    "discountPercentage"
  ];

  for (const key of filterKeysToCheck) {
    const value = filters[key];
    if (Array.isArray(value) && value.length > 0) {
      return true;
    }
  }

  // 3. Check sort
  if (Array.isArray(filters.sort) && filters.sort.length > 0) {
    const firstSort = filters.sort[0];
    if (firstSort?.field && firstSort.field !== "relevance") {
      return true;
    }
  }

  return false;
}

/* boostgroup ID code - ends here*/